<section class="section section--statusMessage">
  <div class="container">
    <div class="wrapper">
      <div class="content fadeinright animation-duration-300">
        <div class="content__main flexColumn flexCenter">
          <article class="mainInfo mainInfo--center">
            <div class="loader__block" *ngIf="isLoading">
              <div class="loading-indicator">
                <p-progressSpinner></p-progressSpinner>
              </div>
              <div class="loading-text loading-text--center"><span>Por favor espera unos instantes, estamos procesando tu solicitud...</span></div>
            </div>
          </article>
        </div>
      </div>
    </div>
  </div>
</section>
